<template>
    <v-container fluid id="footer" class="px-6 pt-6">
        <v-row no-gutters justify="center">
            <v-col cols="12" align="center">
                <img width="200rem" src="@/assets/bns-white.png"><br>
                <v-btn class="my-2" color="white" outlined to="/kapcsolat">Vedd fel velünk a kapcsolatot!</v-btn>
            </v-col>
            <v-col cols="12" align="center">
                <div class="font-weight-bold white--text mt-3">Aloldalak</div>
            </v-col>
            <v-row no-gutters justify="center">
                <div
                    v-for="(n, i) in 5"
                    :key="i"
                    class="mx-2"
                >
                    <router-link :to="menu[i].path" class="white--text" style="text-decoration:none;">{{menu[i].title}}</router-link></div>
                
            </v-row>
            <v-col cols="12" class="mt-2" align="center">
                <div class="font-weight-bold white--text mt-2">Elérhetőségek</div>
            </v-col>
            <v-row no-gutters justify="center" class="mb-3">
                <div class="mt-1">
                    <v-icon color="white" class="mx-2">mdi-phone</v-icon>
                    <a class="white--text mr-7" href="tel:+3614560596">+36-1-456-0596</a>
                </div>
                <div justify="center" class="mt-1">
                    <v-icon color="white" class="mx-2">mdi-email</v-icon>
                    <a href="mailto:office@bns.hu" class="white--text mr-7">office@bns.hu</a>
                </div>
                <div justify="center" class="mt-1">
                    <v-icon color="white" class="mx-2">mdi-map-marker-radius</v-icon>
                    <a href="https://www.google.com/maps/place/BNS+M%C3%A9rn%C3%B6kiroda+Kft./@47.4793991,19.0733306,16.04z/data=!4m9!1m2!2m1!1sbns!3m5!1s0x4741dcf93ab92cdd:0xa8aa20cdde57975!8m2!3d47.4808755!4d19.072694!15sCgNibnMiA4gBAZIBE2luZHVzdHJpYWxfZW5naW5lZXI" target="_blank" class="white--text mr-7">1094 Budapest, Ferenc tér 2.</a>
                </div> 
            </v-row>
            <v-col cols="12">
                <iframe src="https://snazzymaps.com/embed/366631" width="100%" height="250px" style="border:none;"></iframe>
            </v-col>
            <v-row no-gutters justify="center">
                <div align="end" class="white--text">Copyright © BNS Mérnökiroda Kft. 2010.</div>
            </v-row>
        </v-row>
        
    </v-container>
</template>

<script>
export default {
    name: 'Footer',
    components:{
    },
    data(){
        return{
            menu:[
                {title: 'Főoldal', path: '/'},
                {title: 'Rólunk', path: '/rolunk'},
                {title: 'Termékek', path: '/termekek'},
                {title: 'Média', path: '/media'},
                {title: 'Kapcsolat', path: '/kapcsolat'},
            ]
        }
    }
}
</script>

<style scoped>
    #footer{
        background-color: #920825;
    }
    #div{
        border-left: 2px solid white;
        height: 25px;
    }    
    
</style>